// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__g_Z5r","_specific":"styles__specific___AI5M"};